<script>
import ShopProductSwiper from '../../components/shopProductSwiper.vue';
import BtnBackTop from '../../components/btnBackTop.vue';

export default {
    name: "shopHome",
    data() {
        return {
            isLoading: false,
            detail: {
                list: []
            },
        };
    },
    computed: {},
    components: {
        ShopProductSwiper,
        BtnBackTop
    },
    mounted() {
        this.getDate();
    },
    destroyed() {},
    watch: {
        '$route': 'getDate'
    },
    methods: {
        getDate() { 
            this.isLoading = true;
            const id = this.$route.params.id ? this.$route.params.id : 0;
            this.$store.dispatch('getShopHome', {
                category_id: id
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.detail = result.data;
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
    },
};
</script>

<template>
    <div class="shop_home layout_body" v-if="!isLoading">
        <!-- banner -->
        <div class="banner">
            <div class="layout_bg bg" :style="`background-image: url(${ detail.category_image });`"></div>
        </div>
        <div class="layout_main wrapper">
            <template v-for="(item, index) in detail.list">
                <!-- 本季热卖 -->
                <div class="layout_content" v-if="item.type == 1">
                    <div class="top center">
                        <p class="title">{{ item.name }}</p>
                        <p class="desc" v-html="$textToHtml(item.desc)"></p>
                    </div>
                    <ShopProductSwiper :data="item.goods" type="goods"/>
                </div>
                <!-- 把灵感带回家 -->
                <div class="layout_content" v-else-if="item.type == 2">
                    <div class="product_info type3 flex">
                        <div class="text">
                            <p class="sup">{{ item.name }}</p>
                            <p class="name">{{ item.title }}</p>
                            <p class="desc" v-html="$textToHtml(item.content)"></p>
                            <div class="flex" v-if="item.goods.length > 0">
                                <router-link class="btn layout_flex_center" :to="`/shop/detail?id=${item.goods[0].id}`">立即购买</router-link>
                            </div>
                        </div>
                        <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                    </div>
                </div>
                <!-- 发现畅销商品 -->
                <div class="layout_content" v-else-if="item.type == 3">
                    <div class="top center">
                        <p class="title">{{ item.name }}</p>
                        <p class="desc" v-html="$textToHtml(item.desc)"></p>
                    </div>
                    <div class="product_info flex">
                        <div class="text">
                            <p class="name">{{ item.title }}</p>
                            <p class="desc" v-html="$textToHtml(item.content)"></p>
                            <p class="price">RMB {{ item.price }}</p>
                        </div>
                        <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                    </div>
                    <ShopProductSwiper v-if="item.goods.length > 0" :data="item.goods" type="goods"/>
                    <div class="layout_flex_center" v-if="item.link">
                        <div class="btn layout_flex_center" :href="item.link">立即购买</div>
                    </div>
                </div>
                <!-- 版画和印刷品 -->
                <div class="layout_content" v-else-if="item.type == 4">
                    <div class="top flex justify_between align_end">
                        <div class="text">
                            <p class="title">{{ item.name }}</p>
                            <p class="desc" v-html="$textToHtml(item.desc)"></p>
                        </div>
                        <a class="btn layout_flex_center" v-if="item.button_link" :href="item.button_link">{{ item.button_name }}</a>
                    </div>
                    <div class="category_list flex">
                        <router-link class="item" v-for="(_item, _index) in item.series" :key="_index" :to="`/shop/category/${_item.category_parent_id}/filter?id=${_item.category_id}`">
                            <div class="layout_bg cover" :style="`background-image: url(${_item.image});`"></div>
                            <p class="name">{{ _item.name }}</p>
                            <p class="desc" v-if="_item.desc" v-html="$textToHtml(_item.desc)"></p>
                            <p class="type">选购系列</p>
                        </router-link>
                    </div>
                </div>
                <!-- 节日主题 -->
                <div class="layout_content" v-else-if="item.type == 5">
                    <div class="top center">
                        <p class="title">{{ item.name }}</p>
                        <p class="desc" v-html="$textToHtml(item.desc)"></p>
                    </div>
                    <ShopProductSwiper :data="item.series" type="series"/>
                </div>
                <!-- 畅销商品 2 -->
                <div class="layout_content" v-if="item.type == 6">
                    <div class="product_group flex">
                        <div class="item" v-for="(_item, _index) in item.series" :key="_index">
                            <div class="layout_bg cover" :style="`background-image: url(${_item.image});`"></div>
                            <p class="name">{{ _item.name }}</p>
                            <p class="desc" v-if="_item.desc" v-html="$textToHtml(_item.desc)"></p>
                            <div class="layout_flex_center">
                                <router-link class="btn layout_flex_center" :to="`/shop/category/${_item.category_parent_id}/filter?id=${_item.category_id}`">立即购买</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 艺术和艺术工艺品 -->
                <div class="layout_content" v-else-if="item.type == 7">
                    <div class="product_info type2 flex">
                        <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                        <div class="text">
                            <p class="sup">{{ item.name }}</p>
                            <p class="name">{{ item.title }}</p>
                            <p class="desc" v-html="$textToHtml(item.content)"></p>
                            <div class="layout_flex_center" v-if="item.goods.length > 0">
                                <router-link class="btn layout_flex_center" :to="`/shop/detail?id=${item.goods[0].id}`">立即购买</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 当季主题 -->
                <div class="layout_content" v-else-if="item.type == 8">
                    <div class="top flex justify_between align_end">
                        <div class="text">
                            <p class="title">{{ item.name }}</p>
                            <p class="desc" v-html="$textToHtml(item.desc)"></p>
                        </div>
                        <a class="btn layout_flex_center" v-if="item.button_link" :href="item.button_link">{{ item.button_name }}</a>
                    </div>
                    <ShopProductSwiper :data="item.goods" type="goods"/>
                </div>
            </template>
            <!-- 返回顶部按钮 -->
            <BtnBackTop/>
            <!-- <div class="layout_content"></div> -->
            <!-- 0 -->
            <!-- <div class="layout_content">
                <div class="top flex justify_between align_end">
                    <div class="text">
                        <p class="title">当季主题</p>
                        <p class="desc">本季商店有很多潮流款式。快来看看</p>
                    </div>
                    <div class="btn layout_flex_center">所有</div>
                </div>
                <ShopProductSwiper :data="shop"/>
            </div> -->
            <!-- 0 -->
            <!-- <div class="layout_content">
                <div class="top center">
                    <p class="title">节日主题/类别</p>
                    <p class="desc">探索节日宝库，寻找独特的装饰品和礼物</p>
                </div>
                <ShopProductSwiper :data="shop"/>
            </div> -->
            <!-- 0 -->
            <!-- <div class="layout_content">
                <div class="top center">
                    <p class="title">发现畅销商品</p>
                    <p class="desc">漂亮的珠宝、优质的时尚、历史图案，灵感都来自于我们的系列。</p>
                </div>
                <div class="product_info flex">
                    <div class="text">
                        <p class="name">书</p>
                        <p class="desc">是非成败转头空，青山依旧在，惯看秋月春风。一壶浊酒喜相逢，古今多少事，滚滚长江东逝水，浪花淘尽英雄。</p>
                        <p class="price">RMB 98.00</p>
                    </div>
                    <div class="layout_bg cover" :style="`background-image: url();`"></div>
                </div>
                <ShopProductSwiper :data="shop"/>
                <div class="layout_flex_center">
                    <div class="btn layout_flex_center">立即购买</div>
                </div>
            </div> -->
            <!-- 0 -->
            <!-- <div class="layout_content">
                <div class="product_group flex">
                    <div class="item">
                        <div class="layout_bg cover" :style="`background-image: url();`"></div>
                        <div class="name">畅销商品</div>
                        <div class="desc">漂亮的珠宝灵感都来自于我们的系列</div>
                        <div class="layout_flex_center">
                            <div class="btn layout_flex_center">立即购买</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="layout_bg cover" :style="`background-image: url();`"></div>
                        <div class="name">畅销商品</div>
                        <div class="desc">漂亮的珠宝灵感都来自于我们的系列</div>
                        <div class="layout_flex_center">
                            <div class="btn layout_flex_center">立即购买</div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- 0 -->
            <!-- <div class="layout_content">
                <div class="product_info type2 flex">
                    <div class="layout_bg cover" :style="`background-image: url();`"></div>
                    <div class="text">
                        <p class="sup">艺术和艺术工艺品</p>
                        <p class="name">艺术和艺术工艺品</p>
                        <p class="desc">是非成败转头空，青山依旧在，惯看秋月春风。一壶浊酒喜相逢，古今多少事，滚滚长江东逝水，浪花淘尽英雄。</p>
                        <div class="layout_flex_center">
                            <div class="btn layout_flex_center">立即购买</div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!--  -->
            <!-- <div class="layout_content">
                <div class="top center">
                    <p class="title">本季热卖</p>
                    <p class="desc">重点介绍我们系列中的最新热门单品</p>
                </div>
                <ShopProductSwiper :data="shop"/>
            </div> -->
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    width: 100%;
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 8.5rem;
    }
}
.wrapper{
    position: relative;
    @media only screen and (max-width: 750px) {
        width: 100%;
    }
}
.layout_content{
    .top{
        margin-bottom: .4rem;
            @media only screen and (max-width: 750px) {
                text-align: center;
                flex-direction: column;
                align-items: center;
            }
        &.center{
            text-align: center;
        }
        .title{
            font-size: .25rem;
            margin-bottom: .1rem;
            font-weight: bold;
            @media only screen and (max-width: 750px) {
                font-size: .36rem;
            }
        }
        .desc{
            font-size: .18rem;
            @media only screen and (max-width: 750px) {
                font-size: .28rem;
                color: #666;
            }
        }
    }
    .btn{
        padding: 0 .15rem;
        height: .4rem;
        border: 1px solid #000;
        margin-top: .3rem;
        font-size: .18rem;
        cursor: pointer;
        line-height: 1;
        &::after{
            content: '';
            display: block;
            width: .1rem;
            height: .1rem;
            border: 1px solid #000;
            border-width: 1px 1px 0 0;
            transform: rotate(45deg);
        }
        @media only screen and (max-width: 750px) {
            font-size: .22rem;
            height: .6rem;
            margin-top: .4rem;
            padding: 0 .25rem;
            &::after{
                width: .12rem;
                height: .12rem;
                margin-left: .06rem;
            }
        }
    }
    .product_info{
        gap: .4rem;
        margin-bottom: .5rem;
        &:last-child{
            margin-bottom: 0;
        }
        &.type2{
            margin-bottom: 0;
            .text{
                position: relative;
                .name{
                    text-align: left;
                }
                .sup{
                    position: absolute;
                    top: 0;
                    right: 0;
                    font-size: .18rem;
                    text-align: right;
                }
            }
            @media only screen and (max-width: 750px) {
                flex-direction: column;
                .cover{
                    margin-top: -.3rem;
                }
                .text{
                    // position: absolute;
                    .name{
                        text-align: center;
                    }
                    .sup{
                        display: none;
                    }
                    .btn{
                        margin-top: 0;
                    }
                }
            }
        }
        &.type3{
            margin: -.4rem;
            .text{
                padding: .4rem 0 0 1rem;
                .name{
                    text-align: left;
                }
                .desc{
                    margin-bottom: 1rem;
                }
                .sup{
                    font-size: .18rem;
                    margin-bottom: .8rem;
                }
            }
            .cover{
                width: 5rem;
                height: 5.4rem;
            }
            @media only screen and (max-width: 750px) {
                margin: 0;
                .cover{
                    width: 7.5rem;
                    height: 5.4rem;
                    margin-top: -.3rem;
                }
                .text{
                    padding: 0;
                    text-align: center;
                    .name{
                        text-align: center;
                        font-size: .36rem;
                        margin-bottom: .1rem;
                    }
                    .desc{
                        font-size: .28rem;
                        margin-bottom: .4rem;
                    }
                    .sup{
                        font-size: .28rem;
                        margin-bottom: .1rem;
                    }
                    .btn{
                        margin: 0 auto;
                    }
                }
            }
        }
        @media only screen and (max-width: 750px) {
            flex-direction: column-reverse;
        }
        .text{
            padding: 1rem .5rem 0;
            flex: 1;
            @media only screen and (max-width: 750px) {
                padding: 0;
            }
            .name{
                font-size: .25rem;
                margin-bottom: .3rem;
                text-align: center;
                @media only screen and (max-width: 750px) {
                    font-size: .28rem;
                }
            }
            .desc{
                font-size: .18rem;
                margin-bottom: .3rem;
                @media only screen and (max-width: 750px) {
                    font-size: .26rem;
                    color: #666;
                    text-align: center;
                }
            }
            .price{
                font-size: .18rem;
                text-align: center;
                @media only screen and (max-width: 750px) {
                    font-size: .26rem;
                }
            }
        }
        .cover{
            width: 4.8rem;
            height: 4.8rem;
            // border: 1px solid #999;
            flex-shrink: 0;
            @media only screen and (max-width: 750px) {
                width: 7.5rem;
                height: 7.5rem;
                margin: 0 -.3rem;
            }
        }
    }
    .product_group{
        gap: .5rem;
        .item{
            flex: 1;
            font-size: .18rem;
            text-align: center;
            .cover{
                height: 0;
                padding-bottom: 100%;
                border: 1px solid #999;
                margin-bottom: .3rem;
            }
            .name{
                font-weight: bold;
                margin-bottom: .1rem;
            }
        }
        @media only screen and (max-width: 750px) {
            flex-direction: column;
            .item{
                font-size: .26rem;
            }
        }
    }
    .category_list{
        gap: .5rem;
        &.type2{
            .item{
                flex: none;
                width: 3.4rem;
            }
        }
        .item{
            flex: 1;
            font-size: .18rem;
            text-align: center;
            line-height: 2;
            .cover{
                height: 0;
                padding-bottom: 100%;
                // border: 1px solid #999;
                margin-bottom: .3rem;
            }
            .link{
                color: #999;
            }
        }
        @media only screen and (max-width: 750px) {
            flex-direction: column;
            gap: .2rem;
            .item{
                .cover{
                    height: 4.5rem;
                    padding-bottom: 0;
                    margin-bottom: .2rem;
                }
                .name{
                    font-size: .26rem;
                }
                .type{
                    font-size: .22rem;
                    color: #666;
                }
            }
        }
    }
}
</style>